import React, { Component } from 'react';
import axios from 'axios';
import './Instagram.css';


class Instagram extends Component{
    state = {
       instagramFeed: null
    }

    componentDidMount(){
        // axios.get("https://api.instagram.com/v1/users/self/media/recent/?access_token=5763124233.f264a8c.ab944e3ea1e2409fbffb05fd7de49fde")
        // .then(response => {
        //     this.setState((prevState, props)=>{
        //         return {
        //             data: response.data.data
        //         };
        //     })
        // });

        axios.get(`https://www.instagram.com/graphql/query/?query_hash=56a7068fea504063273cc2120ffd54f3&variables={"id":"5763124233","first":18}`)
        .then(response => {
            const latestFeeds = response.data.data.user.edge_owner_to_timeline_media.edges
            this.setState((prevState, props)=>{
                return {
                    instagramFeed: latestFeeds
                };
            })
        });
    }

    render(){ 
        let pictures = null;

        if(this.state.instagramFeed){
            pictures = pictures = this.state.instagramFeed.map((picture) => {
                console.log(picture.node.thumbnail_src)
                return(
                    <div className="instagram-photo-wrapper" key={picture.node.id}>
                        <a 
                            href={picture.node.thumbnail_src} 
                            target="_blank" 
                            rel="noopener noreferrer">
                                <img src={picture.node.thumbnail_src} className="instagram-photo" alt=""/>
                        </a>
                    </div>
                )
            });
            
        }

        return (
            <section className="instagram-section">
                <div className="instagram-title">let's be insta-friends!</div>
                <div className="instagram-username">@bhumiphotography</div>
                <div className="instagram-gallery">
                    {pictures}
                </div>
            </section>
        )
    }
}
export default Instagram;